
import { AmmunitionType } from "@dndModels/Types";
import { 
  Item
} from "@dndModels/item/ItemModel";

export class Ammunition extends Item {
  bundle_size = 1;
  ammunition_type: AmmunitionType = "Arrow";
  
  // If it is worn and can't be worn with something else 
  // of the same type then put it here.  
  // Hat, Goggles, Gloves, Armor, Boots, Clothing, Cape/Cloak

  constructor(obj?: any) {
    super(obj);
    this.item_type = "Ammunition";
    if (obj) {
      this.bundle_size = obj.bundle_size ? +obj.bundle_size : 1;
      if (this.bundle_size === 0) {
        this.bundle_size = 1;
      }
      this.ammunition_type = obj.ammunition_type ? obj.ammunition_type : "Arrow";
    }
  }

  // load(obj: any): void {
  //   super.load(obj);
  //   if (obj) {
  //     this.bundle_size = obj.bundle_size ? +obj.bundle_size : 1;
  //     if (this.bundle_size === 0) {
  //       this.bundle_size = 1;
  //     }
  //     this.ammunition_type = obj.ammunition_type ? obj.ammunition_type : "Arrow";
  //   }
  // }

  toDBObj(): any {
    const base_db_obj = super.toDBObj();
    return {
      ...base_db_obj,
      // _id: this._id,
      // name: this.name,
      // description: this.description,
      // source_type: this.source_type,
      // source_id: this.source_id,
      // item_type: this.item_type,
      // weight: this.weight,
      // cost: this.cost,
      bundle_size: this.bundle_size,
      ammunition_type: this.ammunition_type
    };
  }

  toLight(): any {
    const base_db_obj = super.toLight();
    return {
      ...base_db_obj,
      bundle_size: this.bundle_size,
      ammunition_type: this.ammunition_type
    };
  }

  clone(drop_ids = false): Ammunition {
    const new_obj = new Ammunition();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }

  copy(copyMe: Ammunition, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.item_type = copyMe.item_type;
    this.b_weight = copyMe.b_weight;
    this.cost = copyMe.cost;
    // this.magical = copyMe.magical;
    this.bundle_size = copyMe.bundle_size;
    this.ammunition_type = copyMe.ammunition_type;
  }
}